<div class="card">
  <div class="card-body">
    <h4 class="card-title">Informazioni generali</h4>
    <div class="row">
      <form class="col-sm-12 col-md-6" [formGroup]="infoGenerali">
          <div class="form-group">
            <label for="prodotto" class="control-label col-form-label">Nome Prodotto:</label>
            <input formControlName="prodotto" [ngClass]="{ 'is-invalid': f.prodotto.errors }" type="text" class="form-control" id="prodotto" placeholder="Nome Prodotto">
            <div *ngIf="f.prodotto.errors" class="invalid-feedback">
              <div *ngIf="f.prodotto.errors.required">Campo richiesto</div>
            </div>
          </div>
      </form>
      <div class="col-sm-12 col-lg-3">
        <label for="Tipologia" class="control-label col-form-label">Tipologia:</label>
        <ng-multiselect-dropdown [settings]="unitadropdownSettings" style="width: 80%; " [placeholder]="'Seleziona'" name="Tipologia" [data]="Tipologie"
          [(ngModel)]="TipologieSelezionate">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-sm-12 col-lg-3"  *ngIf="hasCategorie" >
        <label for="categorie" class="control-label col-form-label">Categorie:</label>
        <ng-multiselect-dropdown style="width: 80%; " [placeholder]="'Seleziona'" name="categorie" [data]="Categorie"
          [(ngModel)]="CategorieSelezionate"  [settings]="categoriedropdownSettings" (onFilterChange)="filtroCategoria($event)">
        </ng-multiselect-dropdown>
      </div>

      <form class="col-12" [formGroup]="infoGenerali">
        <div class="row">
          <div class="col-sm-12 col-lg-4">
            <div class="form-group">
              <label for="prezzo" class="control-label col-form-label">Prezzo:</label>
              <input formControlName="prezzo" [ngClass]="{ 'is-invalid': f.prezzo.errors }" type="number" class="form-control"
                id="prezzo" placeholder="Prezzo">
              <div *ngIf="f.prezzo.errors" class="invalid-feedback">
                <div *ngIf="f.prezzo.errors.required">Campo richiesto</div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-lg-4">
            <div class="form-group">
              <label for="codice" class="control-label col-form-label">Codice:</label>
              <input formControlName="codice" [ngClass]="{ 'is-invalid': f.codice.errors }" type="text" class="form-control" id="codice" placeholder="Codice Prodotto">
              <div *ngIf="f.codice.errors" class="invalid-feedback">
                <div *ngIf="f.codice.errors.required">Campo richiesto</div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-lg-4">
            <div class="form-group">
              <label for="codice_produttore" class="control-label col-form-label">Codice Produttore:</label>
              <input formControlName="codice_produttore" [ngClass]="{ 'is-invalid': f.codice_produttore.errors }" type="text" class="form-control" id="codice_produttore" placeholder="Codice Produttore">
              <div *ngIf="f.codice_produttore.errors" class="invalid-feedback">
                <div *ngIf="f.codice_produttore.errors.required">Campo richiesto</div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <img [src]="immagineField" *ngIf="immagineField" style="width: 200px; height: 150px;">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">Immagine:</span>
              </div>
              <div class="custom-file">
                <input formControlName="immagine" [ngClass]="{ 'is-invalid': f.immagine.errors }"
                 type="file" class="custom-file-input" id="immagine" placeholder="" (change)="immaginecambiata($event)">
                <label class="custom-file-label" for="immagine">Upload</label>
              </div>
            </div>
          </div>


          <div class="col-12">
            <div class="form-group">
              <label for="descrizione" class="control-label col-form-label">Descrizione Prodotto:</label>
              <textarea formControlName="descrizione" rows="5" [ngClass]="{ 'is-invalid': f.descrizione.errors }" type="text" class="form-control" id="descrizione" placeholder="Descrizione Prodotto"></textarea>
              <div *ngIf="f.descrizione.errors" class="invalid-feedback">
                <div *ngIf="f.descrizione.errors.required">Campo richiesto</div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="d-md-flex align-items-center" style="padding-right: 25px;">
      <button type="submit" (click)="saveClick()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold" >  Salva  </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</div>
<!-- <div *ngIf="hasParti && selected" >
  <app-parti-prodotto [Variazioni]="selected.variazioni" [Parti]="selected.parti"></app-parti-prodotto>
</div> -->
<div *ngIf="!showaddform" class="card">
  <app-file-uploader [url]="'/prodotti/parti/file'" [(id)]="selected.id" (onChange)="onFileChanged()"></app-file-uploader>
</div>
